'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.PushCartItem = PushCartItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _pushCartActions = require('../../../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

var _functional = require('../../../utils/functional');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartItem(_ref) {
  var _this = this;

  var lineItem = _ref.lineItem;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(lineItem.quantity),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      quantity = _useState4[0],
      setQuantity = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      quantityIsDirty = _useState6[0],
      setQuantityIsDirty = _useState6[1];

  var dispatch = (0, _reactRedux.useDispatch)();

  var handleQuantityChange = (0, _react.useCallback)((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);

            _context.next = 3;
            return dispatch(pushCartActions.updateLineItem({
              lineItem: lineItem,
              quantity: parseInt(quantity, 10)
            }));

          case 3:

            setLoading(false);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  })), [quantity, setLoading]);

  var handleRemove = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);

              _context2.next = 3;
              return dispatch(pushCartActions.removeLineItem({ lineItem: lineItem }));

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function handleRemove() {
      return _ref3.apply(this, arguments);
    };
  }();

  var plusQuantity = (0, _react.useCallback)(function () {
    setQuantity(function (q) {
      return q + 1;
    });
  }, [setQuantity]);

  var minusQuantity = (0, _react.useCallback)(function () {
    if (quantity - 1 <= 0) dispatch(pushCartActions.removeLineItem({ lineItem: lineItem }));

    setQuantity(function (q) {
      return q - 1;
    });
  }, [quantity, setQuantity]);

  (0, _react.useEffect)(function () {
    setQuantityIsDirty(quantity !== lineItem.quantity);
  }, [quantity, lineItem]);

  (0, _react.useEffect)(function () {
    setQuantity(lineItem.quantity);
  }, [lineItem]);

  (0, _react.useEffect)(function () {
    /*
    This is to make sure loading is set to false if the lineItem is removed but a new lineItem takes its place
     One example of this is if you have 5 of the same product in the cart and 1 is discounted down to zero. If you remove the discounted product one of the full price products could take it's place. We don't want an infinite loading state if that is the case
    */

    setLoading(false);
  }, [lineItem]);

  return _react2.default.createElement('div', { className: 'psh-Item' + (loading ? ' psh-Item-loading' : '') }, lineItem.image && _react2.default.createElement('a', { className: 'psh-Item_ImageContainer', href: lineItem.url }, _react2.default.createElement('img', {
    className: 'psh-Item_Image',
    src: (0, _functional.resizeImage)({ src: lineItem.image, size: '220x220' }),
    alt: lineItem.title
  })), _react2.default.createElement('div', { className: 'psh-Item_Content' }, _react2.default.createElement('h5', { className: 'psh-Item_Title' }, _react2.default.createElement('a', { className: 'psh-Item_TitleLink', href: lineItem.url }, lineItem.title)), _react2.default.createElement('p', {
    className: 'psh-Item_Price',
    dangerouslySetInnerHTML: {
      __html: (0, _functional.formatMoney)(lineItem.final_line_price)
    }
  }), _react2.default.createElement('div', { className: 'psh-Item_Controls' }, _react2.default.createElement('div', { className: 'psh-Item_Quantity' }, _react2.default.createElement('button', {
    className: 'psh-Item_QuantityControl psh-Item_QuantityControl-minus',
    onClick: minusQuantity
  }, _react2.default.createElement('span', { className: 'psh-Item_QuantityControlLine psh-Item_QuantityControlLine-line1' })), _react2.default.createElement('input', { className: 'psh-Item_Input', value: quantity, type: 'text', readOnly: true }), _react2.default.createElement('button', {
    className: 'psh-Item_QuantityControl psh-Item_QuantityControl-plus',
    onClick: plusQuantity
  }, _react2.default.createElement('span', { className: 'psh-Item_QuantityControlLine psh-Item_QuantityControlLine-line1' }), _react2.default.createElement('span', { className: 'psh-Item_QuantityControlLine psh-Item_QuantityControlLine-line2' })), quantityIsDirty && _react2.default.createElement('button', { className: 'psh-Item_Update', onClick: handleQuantityChange }, 'Update')), _react2.default.createElement('button', { type: 'button', className: 'psh-Item_Remove', onClick: handleRemove }, window.theme.strings.pushCart.remove))), _react2.default.createElement('div', { className: 'psh-Item_Loading' }, _react2.default.createElement('svg', { viewBox: '0 0 120 30', xmlns: 'http://www.w3.org/2000/svg', fill: '#fff' }, _react2.default.createElement('circle', { cx: '15', cy: '15', r: '15' }, _react2.default.createElement('animate', {
    attributeName: 'r',
    from: '15',
    to: '15',
    begin: '0s',
    dur: '0.8s',
    values: '15;9;15',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  }), _react2.default.createElement('animate', {
    attributeName: 'fill-opacity',
    from: '1',
    to: '1',
    begin: '0s',
    dur: '0.8s',
    values: '1;.5;1',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  })), _react2.default.createElement('circle', { cx: '60', cy: '15', r: '9', fillOpacity: '.3' }, _react2.default.createElement('animate', {
    attributeName: 'r',
    from: '9',
    to: '9',
    begin: '0s',
    dur: '0.8s',
    values: '9;15;9',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  }), _react2.default.createElement('animate', {
    attributeName: 'fill-opacity',
    from: '.5',
    to: '.5',
    begin: '0s',
    dur: '0.8s',
    values: '.5;1;.5',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  })), _react2.default.createElement('circle', { cx: '105', cy: '15', r: '15' }, _react2.default.createElement('animate', {
    attributeName: 'r',
    from: '15',
    to: '15',
    begin: '0s',
    dur: '0.8s',
    values: '15;9;15',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  }), _react2.default.createElement('animate', {
    attributeName: 'fill-opacity',
    from: '1',
    to: '1',
    begin: '0s',
    dur: '0.8s',
    values: '1;.5;1',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  })))));
}

PushCartItem.propTypes = {
  lineItem: _propTypes2.default.object.isRequired
};